import { FieldConfig } from '@core/components/crudbuilder/models/field-config';

export class FieldGroup {
  constructor(
    public dependsOnTarget: string,
    public showWhenValueOfTargetIs: string,
    public fields: Array<FieldConfig>,
  ) {
  }
}
